import React from "react";

export function Logo({ className = "", size = "h-11" }) {
  return (
    <img
      src="/rcc-logo.png"
      alt="Resilience Community Collective"
      data-testid="brand-logo"
      className={`${size} w-auto select-none ${className}`}
      draggable={false}
    />
  );
}

export default Logo;
